import type { ArtifactMedia } from "@rakazo/core";
import { artifactMediaKind } from "@rakazo/core";

type CanPlayType = (kind: ArtifactMedia["kind"], mimeType: string) => string;

function browserCanPlayType(kind: ArtifactMedia["kind"], mimeType: string): string {
  if (typeof document === "undefined") return "";
  return document.createElement(kind).canPlayType(mimeType);
}

/**
 * The inline player for an artifact, or null when it is not media or this browser cannot decode
 * its container; those keep the download card. QuickTime is the MP4 family, which Chromium plays
 * without claiming `video/quicktime`, so it is checked as MP4 too. A file whose codec still fails
 * reports an `error` event, which the player turns into the same download fallback.
 */
export function playableArtifactMedia(
  mimeType: string | null | undefined,
  name: string | null | undefined,
  canPlayType: CanPlayType = browserCanPlayType,
): ArtifactMedia | null {
  const media = artifactMediaKind(mimeType, name);
  if (!media) return null;
  if (canPlayType(media.kind, media.mimeType) !== "") return media;
  if (media.mimeType === "video/quicktime" && canPlayType("video", "video/mp4") !== "") {
    return media;
  }
  return null;
}
